<template>
  <div v-html="policyText"></div>
</template>

<script>
export default {
    data() {
        return {
        policyText: ''
        }
    },
    methods:{
        scrollToTop(){
            window.scrollTo(0,0);
        }
    },
    mounted(){
        this.scrollToTop();

        fetch('https://lrexsite-bucket155400-prod.s3.us-east-1.amazonaws.com/public/PrivacyPolicy.html')
            .then(response => response.text())
            .then(text => {
                this.policyText = text
            })
            .catch(error => {
                console.error('Failed to load privacy policy:', error)
            })
    }
}
</script>

<style scoped>
/* Use :deep or ::v-deep to apply scoped styles to v-html content */

:deep(.main-container) {
  display: flex;
  justify-content: center;
}

:deep(.inner-container) {
  width: 80%;
  text-align: left;
}

:deep(.styled-header) {
  color: #ffffff;
  background-color: #fe804d;
  text-align: center;
  padding-top: 2vw;
  padding-bottom: 2vw;
  width: 20%;
  border-radius: 200px;
}

:deep(.final-styled-header) {
  color: #ffffff;
  background-color: #32ccfe;
  text-align: center;
  padding-top: 2vw;
  padding-bottom: 2vw;
  width: 20%;
  clip-path: polygon(15% 5%, 85% 5%, 100% 50%, 85% 95%, 15% 95%, 0% 50%);
}

@media screen and (max-width: 1000px) {
  :deep(.inner-container) {
    width: 90%;
  }

  :deep(.styled-header),
  :deep(.final-styled-header) {
    width: 200px;
  }
}
</style>